// /home/szymon/kreator2/frontend/src/components/TemplateDetails.js
// v7.0.0 – Dodano guzik i logikę handleDeleteFile() do usunięcia konkretnego pliku z kolekcji

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DropZone from '../DropZone';

export default function TemplateDetails({ backendUrl }) {
  const { id } = useParams();
  const navigate = useNavigate();

  const [coll, setColl] = useState(null);
  const [files, setFiles] = useState([]);
  const [pdfMetadatas, setPdfMetadatas] = useState([]);
  const [pdfPreviews, setPdfPreviews] = useState([]);

  const [error, setError] = useState('');

  // Modal z metadanymi
  const [selectedMetadata, setSelectedMetadata] = useState(null);
  const [showMetadataModal, setShowMetadataModal] = useState(false);

  // Wgrywanie PDF – stany
  const [uploadFile, setUploadFile] = useState(null);
  const [pdfTitle, setPdfTitle] = useState('');
  const [pdfNumber, setPdfNumber] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  // ========== NOWE: Obsługa brakujących czcionek (z OrderDetails) ==========
  const [allFonts, setAllFonts] = useState([]);
  const [pdfMissingFonts, setPdfMissingFonts] = useState({});

  const [missingFontToAdd, setMissingFontToAdd] = useState(null);
  const [missingFontFile, setMissingFontFile] = useState(null);

  useEffect(() => {
    fetchCollection();
    // eslint-disable-next-line
  }, [id]);

  // Pobranie wszystkich czcionek
  useEffect(() => {
    fetchAllFonts();
    // eslint-disable-next-line
  }, [backendUrl]);

  // Wylicz brakujące czcionki
  useEffect(() => {
    if (files.length > 0 || allFonts.length > 0) {
      computeMissingFonts();
    }
  }, [files, allFonts]);

  const fetchCollection = () => {
    fetch(`${backendUrl}/admin/templates/${id}`, { credentials: 'include' })
      .then((res) => {
        if (!res.ok) throw new Error('Nie udało się pobrać kolekcji.');
        return res.json();
      })
      .then((data) => {
        setColl({ id: data.id, name: data.name });
        setFiles(data.files || []);
        setPdfMetadatas(data.pdfMetadatas || []);
        setPdfPreviews(data.pdfPreviews || []);
      })
      .catch((err) => {
        console.error(err);
        setError('Błąd pobierania kolekcji.');
      });
  };

  const fetchAllFonts = () => {
    fetch(`${backendUrl}/admin/fonts`, { credentials: 'include' })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Błąd pobierania czcionek.');
        }
        return res.json();
      })
      .then((data) => {
        setAllFonts(data);
      })
      .catch((err) => {
        console.error('[TemplateDetails] fetchAllFonts =>', err);
      });
  };

  function computeMissingFonts() {
    const missingMap = {};
    files.forEach((f) => {
      const isPdf = f.fileName.toLowerCase().endsWith('.pdf');
      if (!isPdf) return;

      const metaObj = pdfMetadatas.find((m) => m.downloadKey === f.downloadKey);
      if (!metaObj || !metaObj.metadata || !metaObj.metadata.pages) return;

      const usedFonts = new Set();
      metaObj.metadata.pages.forEach((pg) => {
        (pg.items || []).forEach((it) => {
          if (it.fontName) {
            usedFonts.add(it.fontName);
          }
        });
      });

      const missing = [];
      usedFonts.forEach((fontName) => {
        const found = allFonts.find(
          (af) => af.name.toLowerCase() === fontName.toLowerCase()
        );
        if (!found) missing.push(fontName);
      });

      if (missing.length > 0) {
        missingMap[f.downloadKey] = missing;
      }
    });
    setPdfMissingFonts(missingMap);
  }

  // Obsługa wgrywania nowego PDF
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setUploadFile(e.target.files[0]);
    }
  };

  const handleUploadPdf = (e) => {
    e.preventDefault();
    if (!uploadFile) {
      setError('Wybierz plik PDF!');
      return;
    }
    setError('');
    setIsUploading(true);

    const formData = new FormData();
    formData.append('file', uploadFile);
    formData.append('pdfTitle', pdfTitle);
    formData.append('pdfNumber', pdfNumber);

    fetch(`${backendUrl}/admin/templates/${id}/files`, {
      method: 'POST',
      credentials: 'include',
      body: formData
    })
      .then((res) => {
        setIsUploading(false);
        if (!res.ok) throw new Error('Błąd podczas przesyłania pliku PDF.');
        return res.json();
      })
      .then((updated) => {
        setFiles(updated.files || []);
        setPdfMetadatas(updated.pdfMetadatas || []);
        setPdfPreviews(updated.pdfPreviews || []);
        setUploadFile(null);
        setPdfTitle('');
        setPdfNumber('');
      })
      .catch((err) => {
        console.error(err);
        setError('Nie udało się dodać pliku PDF.');
        setIsUploading(false);
      });
  };

  // Metadane PDF
  const handleShowMetadata = (downloadKey) => {
    const metaObj = pdfMetadatas.find((m) => m.downloadKey === downloadKey);
    if (!metaObj) {
      setSelectedMetadata({ error: 'Brak metadanych w pdfMetadatas' });
    } else {
      setSelectedMetadata(metaObj.metadata);
    }
    setShowMetadataModal(true);
  };
  const handleCloseMetadata = () => {
    setShowMetadataModal(false);
    setSelectedMetadata(null);
  };

  const handleGoBack = () => {
    navigate('/admin?tab=templates');
  };

  const handleDeleteCollection = () => {
    if (!window.confirm('Usunąć tę kolekcję?')) return;
    fetch(`${backendUrl}/admin/templates/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    })
      .then((res) => {
        if (!res.ok) throw new Error('Błąd usuwania kolekcji.');
        navigate('/admin?tab=templates');
      })
      .catch((err) => {
        console.error(err);
        setError('Błąd usuwania kolekcji.');
      });
  };

  const handleOpenEditor = (downloadKey) => {
    navigate(`/admin/templates/${id}/pdf-editor/${downloadKey}`);
  };

  // ========== NOWE: usuwanie konkretnego pliku =============
  const handleDeleteFile = async (downloadKey) => {
    if (!window.confirm('Na pewno usunąć ten plik z kolekcji?')) return;
    try {
      setError('');
      const url = `${backendUrl}/admin/templates/${id}/files/${downloadKey}`;
      const res = await fetch(url, {
        method: 'DELETE',
        credentials: 'include'
      });
      if (!res.ok) {
        throw new Error('Błąd usuwania pliku z szablonu.');
      }
      const data = await res.json();
      if (data.files) {
        setFiles(data.files);
      }
      if (data.pdfMetadatas) {
        setPdfMetadatas(data.pdfMetadatas);
      }
      if (data.pdfPreviews) {
        setPdfPreviews(data.pdfPreviews);
      }
    } catch (ex) {
      console.error('[handleDeleteFile]', ex);
      setError('Nie udało się usunąć pliku z kolekcji.');
    }
  };

  // Obsługa brakujących czcionek – dodanie
  const handleOpenAddFont = (fontName) => {
    setMissingFontToAdd(fontName);
    setMissingFontFile(null);
  };
  const handleMissingFontFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setMissingFontFile(e.target.files[0]);
    }
  };
  const handleSubmitAddFont = (e) => {
    e.preventDefault();
    if (!missingFontToAdd || !missingFontFile) return;

    const formData = new FormData();
    formData.append('fontName', missingFontToAdd);
    formData.append('fontFile', missingFontFile);

    fetch(`${backendUrl}/admin/fonts`, {
      method: 'POST',
      credentials: 'include',
      body: formData
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Błąd podczas dodawania czcionki.');
        }
        return res.json();
      })
      .then(() => {
        fetchAllFonts();
        setMissingFontToAdd(null);
        setMissingFontFile(null);
      })
      .catch((err) => {
        console.error('[handleSubmitAddFont]', err);
        setError('Nie udało się dodać czcionki.');
      });
  };

  if (!coll) {
    return <div>Wczytywanie...</div>;
  }

  return (
    <>
      <div className={`order-details-container ${isUploading ? 'uploading' : ''}`}>
        <button onClick={handleGoBack} className="back-button">
          &larr; Wróć do listy szablonów
        </button>

        <h2 style={{ marginBottom: '20px' }}>Kolekcja: {coll.name}</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}

        <button
          onClick={handleDeleteCollection}
          style={{
            backgroundColor: 'red',
            color: '#fff',
            padding: '10px 20px',
            border: 'none',
            borderRadius: 4,
            marginBottom: '20px',
            cursor: 'pointer'
          }}
        >
          Usuń kolekcję
        </button>

        {/* Formularz dodawania nowego PDF */}
        <h3>Dodaj nowy plik PDF</h3>
        <form onSubmit={handleUploadPdf} className="orders-add-form" style={{ maxWidth: '400px' }}>
          <div className="orders-form-group">
            <label>Tytuł PDF:</label>
            <input
              type="text"
              value={pdfTitle}
              onChange={(e) => setPdfTitle(e.target.value)}
              className="orders-input"
            />
          </div>
          <div className="orders-form-group">
            <label>Numer PDF:</label>
            <input
              type="text"
              value={pdfNumber}
              onChange={(e) => setPdfNumber(e.target.value)}
              className="orders-input"
            />
          </div>
          <div className="orders-form-group">
            <label>Plik PDF:</label>
            <input type="file" accept="application/pdf" onChange={handleFileChange} />
          </div>
          <button
            type="submit"
            className="orders-button"
            style={{ padding: '10px 20px', fontSize: '1rem' }}
            disabled={isUploading}
          >
            {isUploading ? 'Wgrywanie...' : 'Wyślij'}
          </button>
        </form>

        <h3 style={{ marginTop: '30px' }}>Lista wgranych plików PDF</h3>
        {files.length === 0 ? (
          <p>Brak plików PDF.</p>
        ) : (
          <table className="orders-table" style={{ marginTop: 10 }}>
            <thead>
              <tr>
                <th>Nazwa pliku</th>
                <th>Numer/Tytuł</th>
                <th>Akcje</th>
              </tr>
            </thead>
            <tbody>
              {files.map((f) => {
                const isPdf = f.fileName.toLowerCase().endsWith('.pdf');
                return (
                  <tr key={f.id}>
                    <td>{f.fileName}</td>
                    <td>
                      {f.docNumber || '-'} / {f.docTitle || '-'}
                    </td>
                    <td>
                      {isPdf && (
                        <>
                          <button
                            onClick={() => handleShowMetadata(f.downloadKey)}
                            style={{
                              marginRight: 8,
                              padding: '8px 12px',
                              fontSize: '0.9rem',
                              cursor: 'pointer'
                            }}
                          >
                            Metadane
                          </button>
                          <button
                            onClick={() => handleOpenEditor(f.downloadKey)}
                            style={{
                              marginRight: 8,
                              padding: '8px 12px',
                              fontSize: '0.9rem',
                              cursor: 'pointer'
                            }}
                          >
                            Otwórz edytor
                          </button>
                          <a
                            href={`${backendUrl}/admin/files/${f.downloadKey}`}
                            download={f.fileName}
                            style={{
                              padding: '8px 12px',
                              fontSize: '0.9rem',
                              backgroundColor: '#eee',
                              borderRadius: 4,
                              textDecoration: 'none',
                              color: '#333',
                              marginRight: 8
                            }}
                          >
                            Pobierz
                          </a>
                          {/* NOWY GUZIK USUWANIA */}
                          <button
                            onClick={() => handleDeleteFile(f.downloadKey)}
                            style={{
                              backgroundColor: '#d9534f',
                              color: '#fff',
                              padding: '8px 12px',
                              fontSize: '0.9rem',
                              borderRadius: 4,
                              border: 'none',
                              cursor: 'pointer'
                            }}
                          >
                            Usuń
                          </button>

                          {/* Brakujące czcionki */}
                          {pdfMissingFonts[f.downloadKey] &&
                            pdfMissingFonts[f.downloadKey].length > 0 && (
                              <div style={{ marginTop: '8px', color: '#d9534f' }}>
                                <strong>Brakujące czcionki:</strong>{' '}
                                {pdfMissingFonts[f.downloadKey].map((mf) => (
                                  <div key={mf} style={{ marginTop: '4px' }}>
                                    <span>{mf} </span>
                                    <button
                                      onClick={() => handleOpenAddFont(mf)}
                                      style={{
                                        marginLeft: '6px',
                                        backgroundColor: '#f0ad4e',
                                        color: '#fff',
                                        border: 'none',
                                        padding: '3px 8px',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      Dodaj czcionkę
                                    </button>
                                  </div>
                                ))}
                              </div>
                            )}
                        </>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        {/* Podglądy stron (miniatury) */}
        <div style={{ marginTop: 30 }}>
          <h4>Podglądy stron (miniatury)</h4>
          {pdfPreviews.length === 0 ? (
            <p>Brak podglądów.</p>
          ) : (
            pdfPreviews.map((prev) => (
              <div key={prev.downloadKey} style={{ marginBottom: 15 }}>
                <p>downloadKey: {prev.downloadKey}</p>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {prev.pages.map((pg) => {
                    const url = `${backendUrl}/admin/raw-file?path=${encodeURIComponent(
                      pg.previewPath
                    )}`;
                    return (
                      <div key={`${prev.downloadKey}-pg${pg.page}`}>
                        <img
                          src={url}
                          alt={`preview pg${pg.page}`}
                          style={{ width: 150, border: '1px solid #ccc' }}
                        />
                        <div style={{ textAlign: 'center' }}>Strona {pg.page}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          )}
        </div>

        {/* Modal z metadanymi PDF */}
        {showMetadataModal && (
          <div className="metadata-modal">
            <div className="metadata-content">
              <h3>Metadane PDF</h3>
              {selectedMetadata ? (
                <pre style={{ maxHeight: 300, overflow: 'auto' }}>
                  {JSON.stringify(selectedMetadata, null, 2)}
                </pre>
              ) : (
                <p>Brak danych</p>
              )}
              <button onClick={handleCloseMetadata} style={{ marginTop: 10 }}>
                Zamknij
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Nakładka z spinnerem w trakcie wgrywania plików */}
      {isUploading && (
        <div className="upload-spinner-overlay">
          <div className="upload-spinner">Trwa wgrywanie...</div>
        </div>
      )}

      {/* Panel (lub sekcja) do dodania brakującej czcionki */}
      {missingFontToAdd && (
        <div
          style={{
            marginTop: '20px',
            background: '#fafafa',
            border: '1px solid #ccc',
            padding: '10px',
            borderRadius: '6px'
          }}
        >
          <h4>
            Dodaj brakującą czcionkę: <em>{missingFontToAdd}</em>
          </h4>
          <form onSubmit={handleSubmitAddFont}>
            <div style={{ marginBottom: '10px' }}>
              <label>Plik (TTF/OTF): </label>
              <input type="file" accept=".ttf,.otf" onChange={handleMissingFontFileChange} />
            </div>
            <button
              type="submit"
              style={{
                backgroundColor: '#5cb85c',
                color: '#fff',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '4px',
                cursor: 'pointer',
                marginRight: '10px'
              }}
            >
              Zapisz
            </button>
            <button
              type="button"
              onClick={() => {
                setMissingFontToAdd(null);
                setMissingFontFile(null);
              }}
              style={{
                backgroundColor: '#777',
                color: '#fff',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Anuluj
            </button>
          </form>
        </div>
      )}
    </>
  );
}
